import { render, staticRenderFns } from "./CarrierChargesBy.vue?vue&type=template&id=bfbc8920&scoped=true&"
import script from "./CarrierChargesBy.vue?vue&type=script&lang=js&"
export * from "./CarrierChargesBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc8920",
  null
  
)

export default component.exports